/**
 * 住院管家
 */

export default [
  /**
   * 选择医院、就诊人
   */
  {
    path: '/butler/select',
    component: () => import('../page/butler/select')
  },
  /**
   * 首页
   */
  {
    path: '/butler/index',
    component: () => import('../page/butler/index')
  },
  /**
   * 缴费记录
   */
  {
    path: '/butler/feelist',
    component: () => import('../page/butler/feelist')
  },
  /**
   * 每日清单
   */
  {
    path: '/butler/daylist',
    component: () => import('../page/butler/daylist')
  },
  /**
   * 充值
   */
  {
    path: '/butler/prepay',
    component: () => import('../page/butler/prepay')
  },
  /**
   * 住院记录
   */
  {
    path: '/butler/recordlist',
    component: () => import('../page/butler/recordlist')
  },
  /**
   * 待支付
   */
  {
    path: "/butler/mz/dzf",
    component: () => import('../page/butler/mz/dzf')
  },
  /**
   * 已支付
   */
  {
    path: "/butler/mz/yzf",
    component: () => import('../page/butler/mz/yzf')
  },
  /**
   * 待支付详情
   */
  {
    path: "/butler/mz/dzf/detail",
    component: () => import('../page/butler/mz/dzf/detail')
  },
  /**
   * 已支付详情
   */
  {
    path: "/butler/mz/yzf/detail",
    component: () => import('../page/butler/mz/yzf/detail')
  },
  /**
   * 选择在线缴费方式
   */
  {
    path: '/butler/pre',
    component: () => import('../page/butler/pre')
  }
]



// WEBPACK FOOTER //
// ./src/router/butler.js